import { animate, state, style, transition, trigger } from '@angular/animations';

export const pseicToasterAnimation = trigger('pseicToasterAnimation', [
    state('*', style({
        position: 'relative',
        opacity: '1',
        transform: 'translateY(0px)'
    })),
    state('void', style({
        position: 'relative',
        opacity: '0',
        transform: 'translateY(50px)'
    })),
    transition(':enter', [
        style({ position: 'relative', opacity: '0', transform: 'translateY(50px)' }),
        animate('127ms cubic-bezier(0.4,0.0,1,1)')
    ]),
    transition(':leave', [
        style({ position: 'relative', opacity: '1', transform: 'translateY(0px)' }),
        animate('127ms cubic-bezier(0.4,0.0,1,1)')
    ])
]);